export default __webpack_public_path__ + "static/media/mountain_church_300.dc770a69.webp";